import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsdaSideNavService } from '../../msda-sidenav/service/msda-sidenav.service';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
    sidnav = false;
    constructor(
        private _router: Router,
        private _auth: AuthService,
        private _sidenavService: MsdaSideNavService
    ) {
        const head = document.getElementsByTagName('head')[0];
        const _js = document.createElement('script');
        _js.src = 'https://static.municipal.gov.ge/scripts/check-email-verification-minified.js'
        _js.type = 'text/javascript';
        head.appendChild(_js);
    }

    async ngOnInit() {
        const isAuthorized = !!localStorage.getItem('access_token');
        // if (!isAuthorized && !crossStorageToken) {
        //   const isAdmin = this._router.url.includes('admin');
        //   const urlEndPoint = isAdmin ? 'private' : 'public';

        //   document.location.href = `https://sso.municipal.gov.ge/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
        //   //   this._router.navigate(['forbidden']);
        // }
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/admin.component.ts